export interface CategoryItem {
  name: string;
  url: string;
  imageSeq: string;
  imageQuery: string;
}

export const categories: CategoryItem[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-01',
    imageQuery: 'Stylish%20fashion%20sneakers%20on%20minimal%20white%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20product%20photography%20with%20gentle%20shadows%2C%20modern%20aesthetic%2C%20neutral%20warm%20tones%2C%20high%20detail%20texture%20visible%20on%20shoe%20material%2C%20simple%20composition%20with%20negative%20space'
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageSeq: 'cat-hoodies-02',
    imageQuery: 'Premium%20hoodie%20sweatshirt%20folded%20neatly%20on%20light%20cream%20backdrop%2C%20soft%20diffused%20studio%20lighting%2C%20minimal%20fashion%20product%20photography%2C%20textured%20fabric%20details%20visible%2C%20warm%20neutral%20aesthetic%2C%20clean%20composition%20with%20ample%20copy%20space'
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageSeq: 'cat-tshirts-03',
    imageQuery: 'Premium%20cotton%20t-shirt%20flat%20lay%20on%20soft%20cream%20surface%2C%20natural%20daylight%20studio%20photography%2C%20minimalist%20fashion%20aesthetic%2C%20fabric%20texture%20visible%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20style%20with%20gentle%20shadows%2C%20simple%20elegant%20composition'
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageSeq: 'cat-jackets-04',
    imageQuery: 'Stylish%20modern%20jacket%20displayed%20on%20minimal%20wooden%20hanger%2C%20soft%20cream%20background%2C%20natural%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20textured%20outerwear%20fabric%20details%2C%20warm%20neutral%20aesthetic%2C%20clean%20sophisticated%20composition'
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageSeq: 'cat-pants-05',
    imageQuery: 'Casual%20trousers%20and%20shorts%20neatly%20arranged%20on%20light%20beige%20surface%2C%20soft%20natural%20daylight%2C%20minimal%20fashion%20product%20photography%2C%20fabric%20texture%20visible%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20composition%20with%20gentle%20shadows'
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageSeq: 'cat-headwear-06',
    imageQuery: 'Trendy%20caps%20and%20beanies%20displayed%20on%20minimal%20white%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20textured%20fabric%20details%2C%20warm%20neutral%20aesthetic%2C%20clean%20simple%20composition%20with%20negative%20space'
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageSeq: 'cat-sets-07',
    imageQuery: 'Coordinated%20matching%20fashion%20set%20outfit%20flat%20lay%20on%20cream%20backdrop%2C%20soft%20diffused%20lighting%2C%20minimalist%20product%20photography%2C%20textured%20fabric%20details%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20style%20with%20ample%20copy%20space'
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageSeq: 'cat-underwear-08',
    imageQuery: 'Premium%20underwear%20basics%20neatly%20folded%20on%20soft%20cream%20surface%2C%20natural%20studio%20lighting%2C%20minimal%20fashion%20product%20photography%2C%20soft%20fabric%20texture%20visible%2C%20warm%20neutral%20aesthetic%2C%20clean%20simple%20composition'
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageSeq: 'cat-jersey-09',
    imageQuery: 'Sports%20jersey%20shirt%20flat%20lay%20on%20light%20neutral%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20sportswear%20photography%2C%20fabric%20texture%20details%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20composition%20with%20negative%20space'
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageSeq: 'cat-accessories-10',
    imageQuery: 'Fashion%20accessories%20collection%20displayed%20on%20cream%20marble%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20various%20textures%20visible%2C%20warm%20neutral%20aesthetic%2C%20clean%20sophisticated%20composition%20with%20gentle%20shadows'
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageSeq: 'cat-bags-11',
    imageQuery: 'Elegant%20fashion%20bag%20displayed%20on%20minimal%20cream%20surface%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20leather%20texture%20visible%2C%20warm%20neutral%20tones%2C%20clean%20sophisticated%20composition%20with%20negative%20space'
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageSeq: 'cat-belts-12',
    imageQuery: 'Premium%20leather%20belt%20coiled%20elegantly%20on%20light%20cream%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20leather%20texture%20details%2C%20warm%20neutral%20aesthetic%2C%20clean%20simple%20composition%20with%20ample%20space'
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageSeq: 'cat-perfumes-13',
    imageQuery: 'Luxury%20perfume%20bottle%20on%20minimal%20cream%20surface%2C%20soft%20studio%20lighting%20with%20gentle%20highlights%2C%20editorial%20product%20photography%2C%20glass%20reflections%20visible%2C%20warm%20neutral%20aesthetic%2C%20clean%20elegant%20composition%20with%20negative%20space'
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageSeq: 'cat-other-14',
    imageQuery: 'Assorted%20fashion%20lifestyle%20items%20arranged%20on%20light%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20various%20textures%20and%20materials%2C%20warm%20neutral%20aesthetic%2C%20clean%20harmonious%20composition%20with%20gentle%20shadows'
  }
];